import { DisplayUser, User } from "@/stores/types/user-types";

export function toDisplayUser(user: User): DisplayUser {
  return {
    ...user,
    display: user.full_name || user.email,
  };
}
